<div class="modal fade" id="dialogFavorecidoCadastro" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Cadastro de Favorecidos</h5>
        <button type="button" class="close" (click)="fechar()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <form [formGroup]="entidadeForm" autocomplete="off">
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="favorecido_cad_cpf_cnpj" class="required">Documento</label>
              <input id="favorecido_cad_cpf_cnpj" formControlName="cpf_cnpj" type="text" class="form-control"
                [imask]="{mask: [ {mask: '000.000.000-00'}, {mask: '00.000.000/0000-00'} ]}" unmask="true"
                (blur)="buscar()">
            </div>
            <div class="form-group col-md-8">
              <label for="favorecido_cad_tipo" class="required">Espécie</label>
              <select [compareWith]="compareFn" id="favorecido_cad_tipo" formControlName="tipo" class="custom-select">
                <option [ngValue]="item" *ngFor="let item of listaTipos">{{item.nome}}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="favorecido_cad_nome" class="required">Razão Social</label>
              <input id="favorecido_cad_nome" formControlName="nome" type="text" class="form-control"
                (keydown.enter)="abrirConsultaFavorecido()">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="favorecido_cad_telefone" class="required">Telefone</label>
              <input id="favorecido_cad_telefone" formControlName="telefone" type="text" class="form-control"
                [imask]="{mask: [ {mask: '0000-0000'}, {mask: '00000-0000'}, {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}"
                unmask="true">
            </div>
            <div class="form-group col-md-4">
              <label for="favorecido_cad_enquadramento" class="required">Enquadramento</label>
              <select id="favorecido_cad_enquadramento" formControlName="enquadramento" class="custom-select"
                (change)="verificarEPP()">
                <option [value]="item.id" *ngFor="let item of listaEnquadramento">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-4" *ngIf="origem_proponente">
              <div class="checkbox checbox-switch switch-primary mt-4 mr-2 float-right">
                <label>
                  <input type="checkbox" [(ngModel)]="proponenteEpp"
                    [ngModelOptions]="{standalone: true}" /><span></span>EPP/ME
                </label>
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="origem_proponente">
            <div class="form-group col-md-4">
              <label for="favorecido_cad_situacao" class="required">Situação</label>
              <select id="favorecido_cad_situacao" [(ngModel)]="proponenteSituacao"
                [ngModelOptions]="{standalone: true}" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaSituacoes">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-8" *ngIf="proponenteSituacao !== 'HABILITADO'">
              <label for="favorecido_cad_motivo" class="required">Motivo</label>
              <textarea id="favorecido_cad_motivo" [(ngModel)]="proponenteMotivo" [ngModelOptions]="{standalone: true}"
                type="text" class="form-control" rows="3"></textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="favorecido_cad_email" class="required">E-mail</label>
              <input id="favorecido_cad_email" formControlName="email" type="text" class="form-control">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="favorecido_cad_responsavel" class="required">Representante</label>
              <input id="favorecido_cad_responsavel" formControlName="responsavel" type="text" class="form-control">
            </div>
          </div>
        </form>
        <!-- <pre>{{entidadeForm?.value|json}}</pre> -->
      </div>
      <div class="modal-footer">
        <div class="row" style="width: 100%;">
          <div class="col-4 pl-0">
            <button (click)="submitForm()" type="button" class="btn btn-sm btn-primary"
              [disabled]="!entidadeForm.valid">
              <i class="fa fa-check"></i> Salvar
            </button>
          </div>
          <div class="col-2 offset-6 text-right">
            <button type="button" class="btn btn-sm btn-link" (click)="fechar()">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<lib-favorecido-busca-dlg [nome]="entidadeForm?.get('nome')?.value" (callback)="callbackFavorecido($event)">
</lib-favorecido-busca-dlg>